// React
import React from "react";

const AnimalChartBlock: React.FC = () => {
  return <div>New Chart Soon...</div>;
};

export default AnimalChartBlock;
